import { ProfileHeaderLeft } from './ProfileHeaderLeft'
import { ProfileHeaderRight } from './ProfileHeaderRight'
import { MemberProfileExtendedType } from 'common/types/MemberProfile'

interface ProfileHeaderProps {
  profile: MemberProfileExtendedType
  reloadProfile: () => void
}

export function ProfileHeader({ profile, reloadProfile }: ProfileHeaderProps) {
  return (
    <div className='h-[220px] pt-14'>
      {/* do not change px-[12px] to px-3 as we have a bug due to global styles! */}
      <div className='flex justify-between px-[12px] md:px-12'>
        <ProfileHeaderLeft profile={profile} />
        <ProfileHeaderRight profile={profile} reloadProfile={reloadProfile} />
      </div>
    </div>
  )
}
